const Shared = {
  setLoading: 'SET_LOADING',
  reset: 'RESET',
};

export const Movie = {
  ...Shared,
  setMovie: 'SET_MOVIE',
};

export const Menu = {
  ...Shared,
  setMenuItems: 'SET_MENU_ITEMS',
};
